import type { FaireProductEntity } from "../../entity_types/product";

export const p_cevskus34x: FaireProductEntity = {
  token: "p_cevskus34x",
  type: "product",
  name: "The Core",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/369334976b943310e72f6bae084ff4857b3ede592c9901bbe699ee02e090b690.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fabbced7289d4459b5c97304a82eefba481560c385dcd784074aa48f0b7a35ae.png",
    "https://cdn.faire.com/fastly/36a49f98858dad5cca162be63b9dabcea72d06ee15cc3a9fbec2ed308224ba9b.png",
    "https://cdn.faire.com/fastly/9b6593e2782c4762a731b9243d1182bf477077c4cf9c54bbc047039599c10983.png",
    "https://cdn.faire.com/fastly/6cc919d933260b9297dd9b4abc177527628d61a18a03e40afa3c118e748b3095.png"
  ],
  priceDollars: 13.3,
  description: "Ripe—Big—Caramel\n\n𝐁𝐚𝐜𝐤𝐬𝐭𝐨𝐫𝐲:\nThe Core is the heart of Highwire. It represents the craft of sourcing and blending components to realize something bigger than the sum of its parts. This applies equally to who we are as a company and to what we try to do with this coffee. The Core is big with red ripe fruit acidity and caramel in the mid palate and finish.\n\n𝐎𝐫𝐢𝐠𝐢𝐧𝐬:\nThe Core has been Highwire's everyday espresso since the beginning, but is equally tasty in a pour over, a French press or other brew methods.\n\n𝐏𝐚𝐢𝐫𝐢𝐧𝐠𝐬:\nPairs well with your playlist for getting things done. We suggest The Fall's \"Totally Wired\", or Queen's \"Under Pressure\".\n\n𝐁𝐫𝐞𝐰:\nUse a scale and grind fresh. Use 16 grams of water at 200°F for each gram of coffee.",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:48.540Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
